import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef, OnChanges, Injector, Inject } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { DataService } from 'src/app/services/data.service';
import { InsurancesEnum, IInsurance, IInsuranceRequest, InsurancesDic, IInsuranceSelected, IInsuranceDic } from './interfaces/aseguradoras';
import { CotizadorService } from 'src/app/services/cotizador.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from './modal/modal.component';
import { firstValueFrom, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/services/modal-service.service';
import { SecurityService } from 'src/app/services/security.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { emailTip, emailTipTo, whatsTip } from './helpers/constants';
import { Icons } from '../modal-alert/enums';
import { BitlyService } from 'src/app/services/bitly.service';
import { SummaryService } from 'src/app/services/summary.service';
import { StrappiService } from 'src/app/services/strappi.service';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { canNotPreauth } from './helpers/Utils';
import { PERIODS, KM_20, FLOW_LEASING_RENTING, FLOW_AFIN, FLOW_RR } from '../../pages/buro/pages/identidad/constants';
import { DOCUMENT } from '@angular/common';
import { SUSTITUECAROPTS, ErrorBuro } from 'src/app/utils/utils';
import { State } from 'src/app/pages/buro/interfaces/states.model';
import { ICampaignsTo } from 'src/app/pages/buro/interfaces/catalogos.model';

@Component({
  selector: 'app-configuration-panel',
  templateUrl: `./configuration-panel.component${environment.templateSuffix}.html`,
  styleUrls: ['./configuration-panel.component.scss'],
})
export class ConfigurationPanelComponent
  implements OnInit, OnDestroy, OnChanges {
  @ViewChild('contentResume') private contentResume!: ElementRef;
  @ViewChild('notInsurances') private notInsurances!: ElementRef;
  @Input() car!: any;
  @Input() metaUrl!: any;
  @Input() isAfin: boolean = false;
  @Input() slashedUrl: string = '';

  readonly totalInsuranceResponses = 3;
  states: any[] = [];
  valueRi: number = 0;
  purchaseValue: number = 0;
  rentPriceFloor: number = 0;
  rentPriceCeil: number = 0;
  purchaseValueFloor: number = 0;
  purchaseValueCeil: number = 0;
  optionsRent: Options = {
    floor: this.rentPriceFloor,
    ceil: this.rentPriceCeil,
    translate: (value: number, label: LabelType): string => {
      return '$' + value.toLocaleString('en');
    },
  };

  optionsFord: Options = {
    floor: this.rentPriceFloor,
    ceil: this.rentPriceCeil,
    translate: (value: number, label: LabelType): string => {
      return '$' + value.toLocaleString('en');
    },
  };

  optionsPurchaseValue: Options = {
    floor: this.purchaseValueFloor,
    ceil: this.purchaseValueCeil,
    translate: (value: number, label: LabelType): string => {
      return '$' + value.toLocaleString('en');
    },
  };
  dataKm: any[] = [];
  defaultValueKm = environment.templateSuffix == '' ? 20000 : 30000;
  valueKmMin: number = 0;
  valueKmMax: number = 0;
  optionsKm: Options = {
    floor: this.valueKmMin,
    ceil: this.valueKmMax,
    ticksArray: [],
    showTicks: true,
    step: 20000,
    translate: (value: number, label: LabelType): string => {
      return value.toLocaleString('en');
    },
  };
  KmArray: any[] = [];
  defaultKm = '0';

  customerTypeId: string = 'B';
  defaultState!: any;
  stateSelected!: any;
  insuranceSelected: IInsuranceSelected = {
    data: [],
    insurance: InsurancesDic[4],
  };

  insuranceRequest!: IInsuranceRequest;
  insurances: IInsurance[][] = [];
  completedResponses = 0;
  insuranceBetter: IInsuranceDic = InsurancesDic[4];
  suma: number = 0;

  qualitas!: any;
  atlas!: any;
  gnp!: any;


  flagProtectionPlus: boolean = false;
  flagSubstituteCar: boolean = false;
  flagMaintenance: boolean = environment.templateSuffix !== '';
  costProtectionPlus: number = 0;
  costSubstituteCar: number = 0;
  loadingServicesPlus: boolean = true;
  valueSubstituteCar: number = 4;
  optionsSubstituteCar = SUSTITUECAROPTS;

  dataQuoter: any;
  subscriptionAllDeadlineSelect!: Subscription;
  subscriptionDeadlineSelect!: Subscription;
  subscriptionInteraction!: Subscription;
  deadlineSelect: any;
  allDeadlineSelect: any;
  isMaxAdvancedRent: any;
  isMaxPurchaseValue: any;
  userId: any = '';
  copyUrl: any = '';

  emailTip = emailTip;
  whatsTip = whatsTip;
  emailTipTo = emailTipTo;

  panelOpenState = false;
  showDetails = false;
  disable = true;

  screenSize = window.innerWidth;
  subscriptionScreen!: Subscription;
  subscriptionUrlParams!: Subscription;

  shareUrl = '';
  carTitle = '';

  screenWidth = window.innerWidth;

  clipboard!: Clipboard;
  bitlyService!: BitlyService;
  summaryService!: SummaryService;
  modalService: ModalService;
  strappiService: StrappiService;
  route: ActivatedRoute;
  keycloakService: KeycloakService;
  personalizaStrappi: any;

  codePromo: string = '';
  codeStatus: string = '';
  showCode: boolean = false;

  templateSuffix = environment.templateSuffix;

  myQuote: any;
  clickEventsubscription!: Subscription;

  tenPercentPrice!: number;
  securityService: SecurityService;

  flagNoSecure: boolean = false;
  isFlowB: boolean = false;

  selectedColorA: string = '';
  selectedColorB: string = '';
  selectedColorC: string = '';

  availableColorsA: string[] = [
    'Azul Ártico',
    'Azul Profundo',
    'Blanco metálico',
    'Blanco Perla',
    'Gris Brillante',
    'Negro Brillante',
    'Rojo Rubí'
  ];
  availableColorsB: string[] = [];
  availableColorsC: string[] = [];
  registrationState: string = '';
  registrationStates: any[] = ['SAN LUIS POTOSÍ'];
  _includeEnganche: boolean = false;
  _engancheMax: boolean = false;
  fifteenPercent: number = 0;
  paramsFord: ICampaignsTo = {} as ICampaignsTo;
  ruleFifteen: boolean = false;
  paramsQuote: any;

  constructor(
    private catalogsService: CatalogsService,
    private cotizadorService: CotizadorService,
    public dialog: MatDialog,
    private dataService: DataService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private injector: Injector
  ) {
    this.userId = this.dataService.getIdKeycloak();
    this.clipboard = this.injector.get<Clipboard>(Clipboard);
    this.bitlyService = this.injector.get<BitlyService>(BitlyService);
    this.summaryService = this.injector.get<SummaryService>(SummaryService);
    this.modalService = this.injector.get<ModalService>(ModalService);
    this.strappiService = this.injector.get<StrappiService>(StrappiService);
    this.route = this.injector.get<ActivatedRoute>(ActivatedRoute);
    this.keycloakService = this.injector.get<KeycloakService>(KeycloakService);
    this.securityService = this.injector.get<SecurityService>(SecurityService);
    this.clickEventsubscription = this.dataService.getSharedFunction().subscribe((data) => {
      if (data === 'preauthorize') {
        this.preauthorize();
      }
    });

    this.isFlowB = this.templateSuffix !== '';
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.getUrlParams();
    }, 1500);

    this.subscriptionDeadlineSelect = this.dataService
      .getDeadlineSelect()
      .subscribe((resSelect: object) => {
        try {
          this.deadlineSelect = resSelect;
          this.dataService.setShowShareLink(false);
          if (this.deadlineSelect?.isSelected) {
            setTimeout(() => {
              this.scrollToResume();
            }, 100);
          }
        } catch (error) {
          console.error('Error fetching deadline select:', error);
        }
      });

    this.subscriptionAllDeadlineSelect = this.dataService
      .getAllDeadlines()
      .subscribe(async (resSelect: object) => {
        try {
          this.allDeadlineSelect = resSelect;
        } catch (error) {
          console.error('Error fetching all deadline select:', error);
        }
      });

    this.tenPercentPrice = this.dataService.getTenPercentPrice();
    this.subscriptionInteraction = this.dataService
      .getInteractionUserPanel()
      .subscribe((resp) => (this.disable = resp));
    this.subscriptionScreen = this.dataService
      .getScreenSize()
      .subscribe((resp) => (this.screenSize = resp));

    this.strappiService.getPlanPage().subscribe((res: any) => {
      this.personalizaStrappi = res.panel_config;
    });
    this.availableColorsB = [...this.availableColorsA];
    this.availableColorsC = [...this.availableColorsA];

    if (this.isFlowB) {
      this.getParamsFord(this.car.idLeaseTech);
    }

  }

  /**
   * Obtiene el porcentaje de la compra para Ford segun la configuración del backoffice initpay_periods
   * Y lo setea en el slider del enganche
   * FORD: Campaign
   * @memberof ConfigurationPanelComponent
   * @returns {void}
   * @private
   * @author victor.mendez
   */
  private getPercentfromPurchaceFord(percents: any) {
    try {
      if (percents) {
        const stepsArray = Object.entries(percents).map(([key, value]) => ({
          value: value as number,
          legend: `${key}%`
        }));

        this.optionsFord = {
          showTicksValues: true,
          stepsArray: stepsArray,
        };

          const index = stepsArray.findIndex(s => s.value === this.paramsQuote.ri);
          if (index !== -1) {
            this.valueRi = stepsArray[index].value + 0.0001; // Forzar cambio
            setTimeout(() => {
              this.valueRi = stepsArray[index].value;
            }, 0);
          }

        this.fifteenPercent = percents[15];
      }
    } catch (error) {
      console.error("Error fetching deadline select:", error);
    }
  }

  async ngOnChanges(changes: any) {
    if (
      changes.car &&
      changes.car.currentValue?.id !== changes.car.previousValue?.id
    ) {
      this.dataQuoter = null;
      this.interactionUser();
      this.getUrlParams();
      this.getState();
      this.getKilometerChange();
    }
  }

  async getUrlParams() {
    this.subscriptionUrlParams = this.route.queryParams.subscribe(async (params) => {

      this.paramsQuote = params['quote']
        ? this.securityService.decryptData(params['quote'])
        : null;

      let _idkeycloak = await this.dataService.getIdKeycloak();
      if (this.paramsQuote?.origin === 'A' && (_idkeycloak.includes('hunnur') || _idkeycloak.includes('ford'))) {
        this.paramsQuote = null;
        this.router.navigate(['/buscador'], { queryParams: {} });
        return;
      }
      if (this.paramsQuote?.origin === 'B' && !(_idkeycloak.includes('hunnur') || _idkeycloak.includes('ford'))) {
        this.paramsQuote = null;
        this.router.navigate(['/buscador'], { queryParams: {} });
        return;
      }

      this.tenPercentPrice = this.dataService.getTenPercentPrice();

      if (this.paramsQuote.typeSustituteCar) {
        this.substituteCarSelect(this.paramsQuote.typeSustituteCar);
      }

      if (this.paramsQuote.stateId) {
        this.defaultState = this.states.find(
          (ele) => ele.id === this.paramsQuote.stateId
        );

        console.log('defaultState-A', this.defaultState);

        this.dataQuoter = {
          ...this.dataQuoter,
          stateId: this.defaultState ? this.defaultState.idTip : 9,
          stateName: this.defaultState ? this.defaultState.stateName : 'CIUDAD DE MÉXICO',
        };

        this.stateSelect(this.defaultState, true);
      }

      if (this.paramsQuote.customerTypeId) {
        this.customerTypeId = this.paramsQuote.customerTypeId;
      }

      if (this.paramsQuote.insurance) {
        this.insuranceSelected.insurance = InsurancesDic.find(
          (ele) => ele.value === this.paramsQuote.insurance
        );
        this.setDataDeadline(
          [
            {
              key: 'insurance',
              value: this.insuranceSelected.insurance?.value,
            },
          ],
          true
        );
      }

      if (this.paramsQuote.km) {
        const parse = this.paramsQuote.km.toLocaleString('en');
        this.defaultKm = parse;
        this.getMaximumRi({ value: parse }, this.paramsQuote.purchaseValue || null);
      }

      if (this.paramsQuote.ri) {

        this.rentChange({ value: this.paramsQuote.ri });
      }

      if (this.paramsQuote.purchaseValue) {
        this.purshaseValueChange({ value: this.paramsQuote.purchaseValue });
      }

      if (this.paramsQuote.protectionPlus) {
        this.flagProtectionPlus = this.paramsQuote.protectionPlus;
        this.changeToggle(1, { checked: this.paramsQuote.protectionPlus });
      }

      if (this.paramsQuote.substituteCar) {
        this.flagSubstituteCar = this.paramsQuote.substituteCar;
        this.changeToggle(2, { checked: this.paramsQuote.substituteCar });
      }

      if (this.paramsQuote.includeMaintenance) {
        this.flagMaintenance = this.paramsQuote.includeMaintenance;
        this.changeToggle(3, { checked: this.paramsQuote.includeMaintenance });
      }

      // SEtea los valores de selección de colores, solo aplica flujo B - Ford
      if (this.isFlowB) {
        if (this.paramsQuote.colors) {
          this.selectedColorA = this.paramsQuote.colors.ColorA;
          this.selectedColorB = this.paramsQuote.colors.ColorB;
          this.selectedColorC = this.paramsQuote.colors.ColorC;

          this.dataQuoter = {
            ...this.dataQuoter,
            colors: {
              ColorA: this.selectedColorA,
              ColorB: this.selectedColorB,
              ColorC: this.selectedColorC,
            },
          };

        }

        if (this.paramsQuote.registrationState) {
          this.registrationState = this.paramsQuote.registrationState;

          this.dataQuoter = {
            ...this.dataQuoter,
            registrationState: this.registrationState,
          };
        }

        if (this.paramsQuote.stateId) {

          this.defaultState = this.states.find(
            (ele) => ele.id === this.paramsQuote.stateId
          );

          this.stateSelect(this.defaultState, true);
          console.log('defaultState-B', this.defaultState);

          this.dataQuoter = {
            ...this.dataQuoter,
            stateId: this.defaultState ? this.defaultState.idTip : 9,
            stateName: this.defaultState ? this.defaultState.stateName : 'CIUDAD DE MÉXICO',
          };

        }

        if (this.paramsQuote.includeEnganche) {
          this._includeEnganche = this.paramsQuote.includeEnganche;
        }

        if (this.paramsQuote.engancheMax) {
          this._engancheMax = this.paramsQuote.engancheMax;
        }

        if (this.paramsQuote.ri) {
          this.valueRi = this.paramsQuote.ri;
        }

      }

    });

  }

  async getState() {
    const resp = await firstValueFrom(this.catalogsService.getStates());
    // FORD: Campaign
    this.states = !this.isFlowB ? resp.data.filter((item: any) => item.idDaVinci !== 99) : resp.data.filter(state => ['GUANAJUATO', 'CHIHUAHUA', 'CIUDAD DE MÉXICO', 'SONORA'].includes(state.stateName));
    this.defaultState = this.states.find((ele) => ele.id === 9);
    this.stateSelect(this.defaultState, false);
  }

  rentChange(event: any) {
    this.valueRi = event.value;
    if (Number(this.valueRi) || this.valueRi === 0) {
      this.setDataDeadline([{ key: 'ri', value: event.value }], true);
    } else {
      this.valueRi = 0;
    }
  }

  purshaseValueChange(event: any) {
    this.dataService.setDeadlineSelect(null);
    this.purchaseValue = event.value;
    this.tenPercentPrice = this.dataService.getTenPercentPrice();
    let quoterType = this.selectFlow();
    this.getServicesPlus();
    this.setDataDeadline([{ key: 'purchaseValue', value: event.value }, { key: 'quoterType', value: quoterType }], true);
  }

  getKilometerChange() {
    this.catalogsService.getRangeKm().subscribe((res) => {
      let filter = res.data.filter((item) => item.status);
      filter.forEach((element: any) => {
        this.KmArray.push(element.range.toLocaleString('en'));
      });

      this.defaultKm = !this.isFlowB ? this.KmArray[0] : this.KmArray[1];
      this.defaultValueKm = +this.defaultKm.split(',').join('');
      this.dataService.setKm(this.defaultValueKm);
      this.getMaximumRi(null, null);
    });
  }

  getMaximumRi(event: any, purchaseValue: number | null) {
    if (event) {
      let prevSelectedKm = this.dataService.getKm();
      const km = +event.value.split(',').join('');
      this.valueKmMin = km;
      this.defaultValueKm = km;
      this.dataService.setKm(km);
      if (!this.validKm({ prevSelectedKm, km })) {
        return;
      }
      this.getServicesPlus();
      this.setDataDeadline([{ key: 'km', value: this.defaultValueKm }], true);
    }
    this.interactionUser();
    this.cotizadorService
      .getRenting(
        this.car.id,
        this.defaultValueKm,
        this.customerTypeId,
        this.selectFlow(),
        this.isFlowB ? 'B' : 'A'
      )
      .subscribe((res) => {
        this.rentPriceCeil = this.isFlowB ? res.ri24.toFixed(2) : res.ri48.toFixed(2);
        this.isFlowB && this.getPercentfromPurchaceFord(res.percents); // Solo se ejecutará en B
        const newOptionsRentPrices: Options = Object.assign(
          {},
          this.optionsRent
        );
        newOptionsRentPrices.floor = this.rentPriceFloor;
        newOptionsRentPrices.ceil = this.rentPriceCeil;
        this.optionsRent = newOptionsRentPrices;
      });

    if (this.isAfin) {

      this.cotizadorService
        .getPurchaseValue(this.car.id, this.defaultValueKm)
        .subscribe((res) => {
          this.purchaseValueFloor = res.min;
          this.purchaseValueCeil = res.max;
          this.purchaseValue = this.purchaseValue ? this.purchaseValue : purchaseValue || this.purchaseValueFloor;
          const newOptionsPurchaseValue: Options = { ...this.optionsPurchaseValue };
          newOptionsPurchaseValue.floor = this.purchaseValueFloor;
          newOptionsPurchaseValue.ceil = this.purchaseValueCeil;
          this.optionsPurchaseValue = newOptionsPurchaseValue;
          this.setDataDeadline(
            [{ key: 'purchaseValue', value: this.purchaseValue }],
            Boolean(this.insuranceSelected.insurance?.value)
          );
        });
    }

  }

  keyupInputRi(event: any) {
    const valueRA = event.target.value;
    if (Number(valueRA)) {
      let value = parseInt(event.target.value.replace(/^0+/, ''));
      this.valueRi = value > this.rentPriceCeil ? this.rentPriceCeil : value;
      if (event.keyCode === 8) this.valueRi = 0;
    }
  }

  keyupInputPurchaseValue(event: any) {
    const valuePV = event.target.value;
    if (Number(valuePV)) {
      let value = parseInt(event.target.value.replace(/^0+/, ''));
      this.purchaseValue =
        value > this.purchaseValueCeil ? this.purchaseValueCeil : value;
      if (event.keyCode === 8) this.purchaseValue = 0;
    }
  }

  changeInputRi(event: any) {
    this.valueRi = parseInt(event.target.value);
    if (Number(this.valueRi) || this.valueRi === 0) {
      this.setDataDeadline([{ key: 'ri', value: this.valueRi }], true);
    } else {
      this.valueRi = 0;
      this.setDataDeadline([{ key: 'ri', value: this.valueRi }], true);
    }
  }

  changeInputPurchaseValue(event: any) {
    const valuePV = event.target.value;
    if (Number(valuePV) && valuePV > 0) {
      this.purchaseValue = parseInt(valuePV);
      this.tenPercentPrice = this.dataService.getTenPercentPrice();
      let quoterType = this.selectFlow();
      this.getServicesPlus();
      this.setDataDeadline(
        [{ key: 'purchaseValue', value: this.purchaseValue }, { key: 'quoterType', value: quoterType }],
        true
      );
      this.interactionUser();
    } else {
      this.purchaseValue = this.purchaseValueFloor;
    }
  }

  getServicesPlus() {
    this.loadingServicesPlus = true;
    this.cotizadorService
      .getServicePlus({
        carId: this.car.id,
        km: this.defaultValueKm,
        cTiD: this.customerTypeId,
        typeSuitCar: this.valueSubstituteCar,
        stateId: this.stateSelected ? this.stateSelected.idTip : 9,
        insurance: this.insuranceSelected?.insurance?.value,
        cpTip: this.stateSelected ? this.stateSelected.cpTip : 6500,
        quoterType: this.selectFlow(),
        flowType: this.isFlowB ? 'B' : 'A',
      })
      .subscribe({
        next: (res: any) => {
          this.costProtectionPlus = res.plusProtectionCost?.toFixed(2);
          this.costSubstituteCar = res.substituteCarCost?.toFixed(2);
          this.loadingServicesPlus = false;
        },
        error: (e) => {
          this.resetInsurance();
        }
      });
  }

  changeToggle(type: number, event: any) {
    let key;

    const typeKeyMap: { [key: number]: string } = {
      1: 'protectionPlus',
      2: 'substituteCar',
      3: 'includeMaintenance'
    };

    key = typeKeyMap[type];

    if (this.dataService.getPeriod() === PERIODS.SIX_MONTHS && this.dataService.getKm() > KM_20) {
      const dialogLogin = this.modalService.openAlert(
        {
          icon: Icons.info,
          title: '',
          content: 'Por el momento no contamos con plazo de 60 meses y Mantenimientos preventivos para el kilometraje seleccionado. Por favor selecciona otro plazo disponible',
          btnAction1: 'Aceptar',
          idBtnAction1: `boton-aviso-crear-cuenta${this.isFlowB ? '-b' : ''}`,
          idBtnAction2: `boton-aviso-iniciar-sesion${this.isFlowB ? '-b' : ''}`,
        },
        false
      );
      dialogLogin.afterClosed().subscribe({ next: () => this.flagMaintenance = false, error: () => this.flagMaintenance = false })

    } else {
      this.interactionUser();
      this.setDataDeadline([{ key, value: event.checked }], true);
    }

  }

  openDialog() {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        insuranceSelected: this.insuranceSelected.insurance,
        insuranceBetter: this.insuranceBetter,
        isAfin: this.isAfin,
      },
      panelClass: 'custom-modalbox',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && this.insuranceSelected.insurance !== result.insurance) {
        this.insuranceSelected = result;
        this.setDataDeadline(
          [
            {
              key: 'insurance',
              value: this.insuranceSelected.insurance?.value,
            },
          ],
          true
        );
        this.interactionUser();
      }
    });
  }

  resetProperties() {
    this.dataService.setDeadlineSelect(null);
    this.qualitas?.unsubscribe();
    this.atlas?.unsubscribe();
    this.gnp?.unsubscribe();
    this.insurances = [];
    this.insuranceSelected = {
      data: [],
      insurance: undefined,
    };
    this.completedResponses = 0;
    this.cotizadorService.insurnaces.next([]);
    this.cotizadorService.insuranceDic.next(InsurancesDic[2]);
  }


  /**
   * Se utiliza unicamente cuando en service-plus ocurre un error.
   * Puede existir una aseguradora pero puede que los montos de la prima no sean adecuados, 
   * esto devolvera un error y reseteara los datos que ya fueron cargados.
   * @memberof ConfigurationPanelComponent
   */
  resetInsurance() {
    this.dataService.setDeadlineSelect(undefined);
    this.gnp?.unsubscribe();
    this.atlas?.unsubscribe();
    this.qualitas?.unsubscribe();
    this.insurances = [];
    this.insuranceSelected = {
      data: [],
      insurance: undefined,
    };
    this.suma = 0;
    this.loadingServicesPlus = false;
  }

  firstResponse(resp: any) {
    if (!resp.hasOwnProperty('data')) {
      if (this.completedResponses === this.totalInsuranceResponses) {
        if (this.suma === 0) {
          this.getServicesPlus();
          this.setDataDeadline(
            [
              { key: 'cpTip', value: this.stateSelected.cpTip },
              { key: 'stateId', value: this.stateSelected.idTip },
              { key: 'stateName', value: this.stateSelected.stateName },
              { key: 'insurance', value: null }
            ],
            true
          );

        }
        this.loadingServicesPlus = false;
      }
      return;
    }

    const { data } = resp;

    let { error, ...op } = data;

    let info: IInsurance[] = Object.values(op);

    let amount = this.isAfin ? 5 : 4;

    // FORD: Campaign
    info.length = this.isFlowB ? 5 : info.length;

    if (info.length !== amount) {
      return;
    }

    this.insurances.push(info);
    this.cotizadorService.insurnaces.next(this.insurances);
    const insurance = InsurancesDic.find(
      (ele) => ele.key === info[0]!.insurance
    );
    if (this.insuranceSelected.insurance === undefined) {
      this.insuranceSelected.data = info;
      this.insuranceSelected.insurance = insurance;
      this.cotizadorService.insuranceDic.next(insurance!);
      this.getServicesPlus();
      this.setDataDeadline(
        [
          { key: 'cpTip', value: this.stateSelected.cpTip },
          { key: 'stateId', value: this.stateSelected.idTip },
          { key: 'stateName', value: this.stateSelected.stateName },
          { key: 'insurance', value: this.insuranceSelected.insurance?.value }
        ],
        true
      );
    }
  }

  resultOfRequestNotSuccess() {
    if (this.isFlowB) {
      if ((!this.selectedColorA || !this.selectedColorB || !this.selectedColorC || !this.registrationState)) {
        return true;
      }
    } else {
      this.suma = this.insurances.length;
      if (this.completedResponses === this.totalInsuranceResponses && this.suma === 0) {
        return;
      } else {
        this.dataService.sendSharedFunction(false);
        return false;

      }

    }
    return false;
  }


  substituteCarSelect(value: any) {
    this.valueSubstituteCar = value;
    this.getServicesPlus();
    this.setDataDeadline(
      [{ key: 'typeSustituteCar', value: this.valueSubstituteCar }],
      true
    );
  }

  /**
   * Se utiliza para obtener la información de las aseguradoras de FORD
   * FORD: Campaign
   * @returns {void}
   * @author victor.mendez
   * @memberof ConfigurationPanelComponent
   */
  getInsuranceFordB() {
    const requestQualitas = {
      idState: 9,
      cpTip: 54769,
      idTip: this.car.id,
      year: this.car.year,
      priceWithIva: this.car.priceWithIva,
      insurance: InsurancesEnum.QUALITAS,
      quoterType: this.selectFlow(),
      flowType: 'B',
      version: this.car.version,
      userId: this.userId,
      idLeasetech: this.car.idLeaseTech
    };

    this.qualitas = this.cotizadorService
      .getInsuranceInfo(requestQualitas)
      .subscribe({
        next: (resp) => {
          this.completedResponses = 3;
          this.firstResponse(resp);
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  stateSelect(state: State, flagChangeData: boolean) {
    this.stateSelected = state;
    const { idTip, year, priceWithIva } = this.car;
    this.resetProperties();

    if (!this.isFlowB) {
      this.insuranceRequest = {
        cpTip: this.stateSelected.cpTip,
        idState: this.stateSelected.idTip,
        priceWithIva,
        insurance: InsurancesEnum.QUALITAS,
        idTip,
        year,
        quoterType: this.selectFlow(),
        // Estos parametros unicamente se utilizan para flujo B espcificamente para FORD: Campaign
        // Es para diferenciar el costo del seguro por version y el tipo de flujo
        flowType: 'A',
        version: this.car.subBrand,
        userId: this.userId,
        idLeasetech: this.car.idLeaseTech,
      };

      const requestQualitas = {
        ...this.insuranceRequest,
        insurance: InsurancesEnum.QUALITAS,
      };

      const requestAtlas = {
        ...this.insuranceRequest,
        insurance: InsurancesEnum.ATLAS,
      };

      const requestGNP = {
        ...this.insuranceRequest,
        insurance: InsurancesEnum.GNP,
      };

      this.qualitas = this.cotizadorService
        .getInsuranceInfo(requestQualitas)
        .subscribe({
          next: (resp) => {
            this.completedResponses += 1;
            this.firstResponse(resp);
          },
          error: (err) => {
            console.error(err);
          }
        });

      this.atlas = this.cotizadorService
        .getInsuranceInfo(requestAtlas)
        .subscribe({
          next: (resp) => {
            this.completedResponses += 1;
            this.firstResponse(resp);
          },
          error: (err) => {
            console.error(err);
          }
        });

      this.gnp = this.cotizadorService
        .getInsuranceInfo(requestGNP)
        .subscribe({
          next: (resp) => {
            this.completedResponses += 1;
            this.firstResponse(resp);
          },
          error: (err) => {
            console.error(err);
          }
        });
    } else {
      this.getInsuranceFordB();
    }

  }

  /**
   * Se utiliza para actualizar el estado de registro de  FORD
   * @param value {string}
   * @author aldo.disraeli
   */
  registrationStateSelect(value: string): void {
    this.registrationState = value;
    this.dataQuoter = {
      ...this.dataQuoter,
      registrationState: this.registrationState,
    };
    this.dataService.setQuoterData(this.dataQuoter);
  }

  /**
   * Se utiliza para actualizar los colores disponibles de  FORD
   * @returns {void}
   * @author aldo.disraeli
   */
  updateAvailableColors() {
    const usedColors = new Set([this.selectedColorA, this.selectedColorB]);

    this.availableColorsB = this.availableColorsA.filter(color => color !== this.selectedColorA);

    if (!this.availableColorsB.includes(this.selectedColorB)) {
      this.selectedColorB = '';
    }

    this.availableColorsC = this.availableColorsA.filter(color => !usedColors.has(color));

    if (!this.availableColorsC.includes(this.selectedColorC)) {
      this.selectedColorC = '';
    }

    this.dataQuoter = {
      ...this.dataQuoter,
      colors: {
        ColorA: this.selectedColorA || null,
        ColorB: this.selectedColorB || null,
        ColorC: this.selectedColorC || null,
      },
    };

    this.dataService.setQuoterData(this.dataQuoter);

  }

  setDataDeadline(dataChange: any, flagChangeData: boolean) {
    const idTemp = this.dataQuoter?.carId || 0;
    const idCar = this.car?.id || 0;

    if (this.isFlowB) {
      this._includeEnganche = this.valueRi !== 0;
      this._engancheMax = this.valueRi > 0 && this.valueRi === this.fifteenPercent;
      this.ruleFifteen = !!(this._engancheMax && this.paramsFord.cash_insurance);
    }

    if (flagChangeData) {
      if (this.dataQuoter) {
        this.dataQuoter = {
          ...this.dataQuoter,
          includeEnganche: this._includeEnganche,
          engancheMax: this._engancheMax
        };
        dataChange.forEach((item: any) => {
          this.dataQuoter[item.key] = item.value;
        });

        if (idTemp !== idCar) {
          this.dataQuoter.carId = idCar;
        }

        this.dataQuoter.quoterType = this.selectFlow();

      } else {
        //TODO: Revisar la logica y llamados de la funcion stateSelect para no setear los valores de stateId y stateName por default.
        this.dataQuoter = {
          carId: this.car.id,
          cpTip: this.stateSelected ? this.stateSelected.cpTip : 6500,
          customerTypeId: this.customerTypeId,
          insurance: this.insuranceSelected.insurance?.value,
          km: this.defaultValueKm,
          protectionPlus: this.flagProtectionPlus,
          ri: this.valueRi,
          stateId: this.stateSelected ? this.stateSelected.idTip : 9,
          stateName: this.stateSelected ? this.stateSelected.stateName : 'CIUDAD DE MÉXICO',
          substituteCar: this.flagSubstituteCar,
          typeSustituteCar: this.valueSubstituteCar,
          userId: this.userId,
          purchaseValue: this.purchaseValue,
          quoterType: this.selectFlow(),
          codePromo: this.codePromo,
          includeMaintenance: this.flagMaintenance,
          includeEnganche: this._includeEnganche,
          engancheMax: this._engancheMax,
          flowType: this.isFlowB ? 'B' : 'A',
        };
      }

      this.dataService.setQuoterData(this.dataQuoter);
      this.interactionUser()
    }
  }

  checkRi = () => {
    if (this.isFlowB) {
      this.isMaxAdvancedRent = this.deadlineSelect?.initialPaymentDetail?.isMaxAdvancedRent;
      return this.isMaxAdvancedRent ? this.deadlineSelect?.initialPaymentDetail?.advancedRent : this.valueRi;
    } else {
      return this.valueRi;
    }
  };

  checkPurchaseValue = () => {
    this.isMaxPurchaseValue = this.isAfin
      ? !this.deadlineSelect?.isOriginalPurchaseValue
      : false;
    return this.isMaxPurchaseValue
      ? this.deadlineSelect?.purchaseValue
      : this.purchaseValue;
  };

  compare() {
    if (this.userId === '') {
      this.alertLogin('Para comparar autos por favor inicia sesión o registrate');
    } else {
      const {
        idQuoter,
        concept,
        period,
        monthlyPayment,
        initialPayment,
        depositIncome,
      } = this.deadlineSelect;
      const { priceWithIva, subBrand, brand } = this.car;
      const { stateName } = this.stateSelected;
      const insuranceName = this.insuranceSelected.insurance?.key;
      const dataEncrypt = {
        ...this.dataQuoter,
        stateName,
        idQuoter,
        deadlineConcept: concept,
        deadlinePeriod: period,
        monthlyPayment,
        initialPayment,
        depositIncome,
        priceWithIva,
        subBrand,
        brand,
        insuranceName,
      };
      const urlHash = this.securityService.encryptData(dataEncrypt, false);
      this.router.navigate(['/comparar-unidad'], {
        queryParams: { quote: urlHash },
      });
    }
  }

  preauthorize() {
    if (this.userId === '') {
      this.alertLogin(
        'Por favor inicia sesión o registrate para continuar con tu aprobación'
      );
    } else {
      this.sendPreauthorize();
    }
  }

  applyCode() {
    this.disable = true;
    this.catalogsService.validateCodePromo(this.codePromo).subscribe({
      next: (res) => {
        this.setDataDeadline(
          [{ key: 'codePromo', value: this.codePromo }],
          true
        );
        this.modalService.openAlert(
          {
            title: 'Código de promoción aplicado exitosamente',
            content: 'Verás reflejado el ajuste de tu mensualidad en la tabla de planes.',
            btnAction1: 'Entendido',
            btnAction2: null,
            icon: Icons.success,
            idBtnAction1: null,
            idBtnAction2: null,
          },
          false
        );
        this.codeStatus = 'valid';
      },
      error: (err) => {
        this.disable = false;
        let _error = err.error.userError;
        if (_error.includes('válido')) {
          this.codeStatus = 'invalid';
        } else if (_error.includes('vigencia')) {
          this.codeStatus = 'novalidity';
        } else if (_error.includes('inactivo')) {
          this.codeStatus = 'inactive';

        }

      },
    });
  }

  changeCode() {
    this.codePromo = '';
    this.codeStatus = '';
    this.document.getElementById('inputCodigo')?.focus();
  }

  keyupInputCode() {
    if (this.codeStatus === 'valid' || this.codeStatus === 'invalid' || this.codeStatus === 'novalidity')
      this.codeStatus = '';
  }

  alertLogin(text: string) {
    const { concept, period } = this.deadlineSelect;
    const dataEncrypt = {
      ...this.dataQuoter,
      deadlineConcept: concept,
      dealinePeriod: period,
      isAfin: this.isAfin,
      origin: this.isFlowB ? 'B' : 'A'
    };
    localStorage.setItem('dataQuote', this.securityService.encryptData(dataEncrypt, false));
    const dialogLogin = this.modalService.openAlert(
      {
        title: '¡Aviso!',
        content: text,
        btnAction1: 'Crear Cuenta',
        btnAction2: 'Iniciar Sesión',
        icon: Icons.info,
        idBtnAction1: `boton-aviso-crear-cuenta${this.isFlowB ? '-b' : ''}`,
        idBtnAction2: `boton-aviso-iniciar-sesion${this.isFlowB ? '-b' : ''}`,
      },
      false
    );
    dialogLogin.afterClosed().subscribe((result) => {
      localStorage.setItem('flowType', this.isFlowB ? 'B' : 'A');

      if (result === false) this.keycloakService.login({
        redirectUri: window.location.href
      });

      if (result === true) this.keycloakService.register({
        redirectUri: window.location.href
      });
    });
  }

  sendPreauthorize() {
    const request = {
      quoterId: this.deadlineSelect.idQuoter,
      carId: this.car.id,
      concept: this.deadlineSelect.concept,
      period: this.deadlineSelect.period,
      depositIncome: this.deadlineSelect.depositIncome,
      idKeycloak: this.dataService.getIdKeycloak(),
      priceWithIva: this.car.priceWithIva,
      monthlyPayment: this.deadlineSelect.monthlyPayment,
      update: false,
    };

    this.cotizadorService.preauthorize(request).subscribe((res) => {
      if (
        res.maxPaymentCapacity &&
        res.maxPaymentCapacity < this.deadlineSelect.monthlyPayment
      ) {
        const msg =
          'Lo sentimos, el producto que seleccionaste sobrepasa la capacidad de pago máxima que te hemos asignado. Por favor selecciona otra opción';
        this.modalService.showAlertWithoutIds(
          msg,
          Icons.error,
          false,
          '¡Aviso!'
        );
        return;
      }

      let quoterIdPrevius = res.data._source
        ? res.data._source.quoterId
        : res.data.quoterId;

      if (this.deadlineSelect.idQuoter === quoterIdPrevius)
        this.router.navigate(['/genera-oportunidad']);
      else
        this.processExists(res.data._source.carId, request, res.data._source);
    });
  }

  processExists(idCarPrevius: any, request: any, client: any) {
    this.catalogsService.getQuoteCarById(idCarPrevius).subscribe((resCar) => {
      let carPrevius = resCar.data.hits.hits[0]._source;

      const hasHistorial = client?.E7?.data?.errors && (client?.E7?.data?.errors[0]?.cveError === ErrorBuro.NO_HISTORIAL)

      const dialogRef = this.modalService.openAlert(
        {
          title: '¡Aviso!',
          content: hasHistorial
            ? `No cuentas con historial crediticio y es requerido para poder continuar con el proceso. Gracias por tu preferencia.`
            : `Existe un proceso de pre aprobación para tu <b>${carPrevius.brand} ${carPrevius.subBrand}</b>, ¿Lo quieres sustituir?`,
          btnAction1: hasHistorial ? 'Entendido' : 'Si, lo quiero sustituir',
          btnAction2: hasHistorial ? null : 'No, ir a mi ultimo paso',
          icon: Icons.info,
          idBtnAction1: hasHistorial ? `boton-aviso-no-historial` : `boton-aviso-quiero-sustituir$`,
          idBtnAction2: hasHistorial ? null : `boton-aviso-ir-ultimo-paso`,
        },
        true
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (hasHistorial) {
          this.router.navigate(['/home']);
          return;
        }

        if (result) {
          if (canNotPreauth(client)) {
            const msg =
              'Tu cotización actual está en un paso que no se puede sustituir. Contáctanos para obtener más ayuda';
            this.modalService.showAlertWithoutIds(msg, Icons.error, false, '');
            return;
          }

          request.update = true;
          this.dataService.setUpdatePreauthorize(true);
          this.cotizadorService.preauthorize(request).subscribe((resUpdate) => {
            if (resUpdate.status === 200)
              this.router.navigate(['/genera-oportunidad']);
          });
        } else this.router.navigate(['/genera-oportunidad']);
      });
    });
  }

  scrollToResume() {
    if (this.screenSize > 767) {
      this.contentResume?.nativeElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }
  }

  interactionUser() {
    this.dataService.setInteractionUserPanel(true);
  }

  ngOnDestroy(): void {
    this.subscriptionDeadlineSelect?.unsubscribe();
    this.subscriptionInteraction?.unsubscribe();
    this.subscriptionScreen?.unsubscribe();
    this.destroyObservableUrlParams();
    this.clickEventsubscription.unsubscribe();
    this.subscriptionAllDeadlineSelect.unsubscribe();
  }

  destroyObservableUrlParams() {
    this.subscriptionUrlParams?.unsubscribe();
  }

  validateBetter() {
    const isComplete = this.completedResponses <= this.totalInsuranceResponses && this.completedResponses > 0;
    const isMoreIns = this.insurances.length > 1;

    if (isComplete && isMoreIns) {
      this.compareInsurances();
      return this.insuranceBetter.key !== this.insurances[0][0].insurance;
    }
    return false;
  }

  compareInsurances() {
    if (this.insurances.length === 0) {
      return;
    }

    let result = this.insurances.map((arr) => arr.filter((obj) => obj.plazo === '36'))
      .flat().reduce((minimo, current) => (current.cost < minimo.cost ? current : minimo));

    this.insuranceBetter = this.findNewBetter(result);
  }

  findNewBetter(insuranceToCompare: IInsurance) {
    return InsurancesDic.find((ele) => ele.key === insuranceToCompare.insurance)!;
  }

  validKm({ prevSelectedKm, km }: { prevSelectedKm: number, km: number }) {
    if (this.dataService.getSelectedMaintenanceExpenses() && km > KM_20 && this.dataService.getPeriod() === PERIODS.SIX_MONTHS) {
      let prevSelectedKmValue = this.getPrevKmSelected({ prevSelectedKm });
      const alert = this.modalService.openAlert(
        {
          icon: Icons.info,
          title: '',
          content: 'Por el momento no contamos con plazo de 60 meses y Mantenimientos preventivos para el kilometraje seleccionado. Por favor selecciona otro plazo disponible',
          btnAction1: 'Aceptar',
          idBtnAction1: `boton-aviso-crear-cuenta${this.isFlowB ? '-b' : ''}`,
          idBtnAction2: `boton-aviso-iniciar-sesion${this.isFlowB ? '-b' : ''}`,
        },
        false
      );
      alert.afterClosed().subscribe({
        next: () => {
          this.defaultKm = `${prevSelectedKmValue}`;
          this.dataService.setKm(+`${prevSelectedKmValue}`.replace(',', ''));
        }
      })
      return false;
    }
    return true;
  }

  getPrevKmSelected({ prevSelectedKm }: { prevSelectedKm: number }) {
    return this.KmArray.map(km => {
      return {
        kmOriginal: km,
        kmClone: km.replace(',', '')
      }
    }).filter(({ kmClone }) => prevSelectedKm == kmClone).shift()?.kmOriginal;
  }

  /**
   * Se utiliza para seleccionar el flujo de la cotización
   * @returns {string}
   * @date 2025-06-25
   * @updated victor.mendez
   * @description Se agrega el flujo B para  la cotizacion de Ford
   */
  selectFlow() {
    if (this.isFlowB) {
      return FLOW_RR;
    } else {
      if (this.isAfin) {
        return (this.purchaseValue > this.tenPercentPrice) && this.tenPercentPrice > 0 ? FLOW_RR : FLOW_AFIN;
      }
      return FLOW_LEASING_RENTING;
    }
  }

  /**
   * Valida el Input para FLujo B de Enganche que sea el monto minimo y MAximo
   * @param {Event} event
   * @memberof ConfigurationPanelComponent
   * @author victor.mendez
   */
  validateRangeInputMax(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = Math.round(inputElement.valueAsNumber);
    const max = this.rentPriceCeil;

    if (value < 0) {
      value = 0;
    } else if (value > max) {
      value = max;
    }
    inputElement.value = value.toString();
  }

  /**
   * Se utiliza para obtener los parametros de la campaña Ford
   * @param {number} idLeasetech
   * @memberof ConfigurationPanelComponent
   * @author victor.mendez
   * @date 2025-04-24
   */
  getParamsFord(idLeasetech: number): void {
    this.catalogsService.getParamsFord(idLeasetech).subscribe((resCar: ICampaignsTo) => {
      this.paramsFord = resCar;
    });
  }

}